import { render, staticRenderFns } from "./ViewerAdmin.vue?vue&type=template&id=c00d7a02"
import script from "./ViewerAdmin.vue?vue&type=script&lang=ts"
export * from "./ViewerAdmin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports